module.exports = __webpack_public_path__ + "assets/img/ysdgzh.4257ce45.png";